
import { Vue, Component, Prop } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

import ModalContainer from "@/components/modal/ModalContainer.vue";
import ModalHeader from "@/components/modal/ModalHeader.vue";
import CrossIcon from "@/components/icons/CrossIcon.vue";
import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

@Component({
  components: {
    ModalSectionsDivider,
    CrossIcon,
    ValidationObserver,
    ModalContainer,
    ModalHeader,
  },
})
export default class ModalFullScreen extends Vue {
  @Prop({ type: Boolean, default: false }) readonly withBgClickEvent!: boolean;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: Boolean, default: false }) readonly showCustomTitle!: boolean;
  @Prop({ type: String }) readonly modalId!: string;
  @Prop({ type: String, default: "" }) readonly contentClass!: string;
  @Prop({ type: String, default: "" }) readonly portal_class!: string;
  @Prop({ type: String, default: "" }) readonly actionClass!: string;



  get renderTitle(): boolean {
    return Boolean(this.titleToShow || this.showCustomTitle);
  }

  get titleToShow(): string {
    if (this.showCustomTitle) {
      return "";
    }
    return this.title;
  }

  get modalHeaderSlotClasses(): Record<string, boolean> {
    return {
      "w-full": this.showCustomTitle,
    };
  }

  onClose(): void {
    if (this.withBgClickEvent) {
      this.$emit("close");
    }
  }
}
